export default function (context) {
  context.$axios.onRequest((config) => {
    config.withCredentials = true;
    config.headers.common['X-PLANNR-ACCOUNT-UUID'] = context.store.getters['user/currentAccountUuid'];

    return config;
  });

  // Ping the backend after every 25 API requests to keep the user's session cookie from expiring if they're active.
  let apiCounter = 0;

  context.$axios.onRequest((config) => {
    if (!config.url.startsWith($nuxt.$api.laravelURL + '/api')) {
      return;
    }

    apiCounter++;

    if (apiCounter % 25 === 0) {
      apiCounter = 0;
      context.$authService.refreshSession();
    }
  });

  context.$axios.onError(async (error) => {
    // If the user's session cookie has expired but their remember me cookie is still valid then refresh their session and retry the original request.
    if (
      error.response &&
      error.response.status === 401 &&
      context.$authService.shouldRefreshSession() &&
      error.config.url.startsWith($nuxt.$api.laravelURL + '/api') &&
      ! error.config.url.startsWith($nuxt.$api.laravelURL + '/refresh')
    ) {
      const response = await context.$authService.refreshSession();

      if (response.status === 204) {
        return context.$axios.request(error.config);
      }

      return Promise.reject(error);
    }

    // Otherwise we have a real authentication error so log the user out and redirect.
    if (error.response && error.response.status === 401 && context.$authService.loggedIn) {
      await context.$authService.nuxtLogout();

      if (context.$authService.authStrategy === 'plannrProduction') {
        context.$authService.redirectToLaravel();
        return Promise.resolve();
      }

      context.redirect('/');
      return Promise.reject(error);
    }

    if (error.response && error.response.status === 500) {
      $nuxt.$emit(
        'notification',
        'Server error. Please contact info@plannrcrm.com if the error still persists.',
        'warning',
        true,
        10000
      );

      return Promise.reject(error);
    }

    return Promise.reject(error);
  });
}
